module.exports = __webpack_public_path__ + "img/606857_9BA894_8C9C83_8C9483-256px.fea07f81.png";